import { inputBorderRadiusMedium } from "src/styles/components/constants";

export const senecFormControlTheme = {
    styleOverrides: {
        root: {
            borderRadius: inputBorderRadiusMedium,
            "input, textarea": {
                transform: "translateY(8px)",
                fontSize: 18,
            },
        },
    },
};
